module.exports = __webpack_public_path__ + "img/msg06.39a83c9e.png";